import { useCallback, useEffect, useState } from "react";
import TravelMap from "./components/travel-map";
import { BaseUrl } from "../../BaseUrl/BaseUrl";
import { useSelector } from "react-redux";

export default function LeadTracker() {
  const [details, setDetails] = useState(null);

  const { loginData, singleEmployee } = useSelector(
    (state) => state.userReducer
  );

  const getTravelDetails = useCallback((id, token) => {
    fetch(`${BaseUrl}/api/employees/${id}/travelDetails`, {
      headers: {
        authorization: `Bearer ${token}`,
      },
    })
      .then((res) => res.json())
      .then((res) => {
        if (res) {
          if (res.success && res.data) {
            setDetails(res.data);
          }
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  // Get travel details on initial load
  useEffect(() => {
    getTravelDetails(singleEmployee?.id, loginData?.accessToken);
  }, [loginData, singleEmployee, getTravelDetails]);

  // Get travel details every 30 seconds
  useEffect(() => {
    if (singleEmployee && loginData) {
      setInterval(() => {
        getTravelDetails(singleEmployee?.id, loginData?.accessToken);
      }, 1000 * 30); // 10 seconds
    }
  }, [loginData, singleEmployee, getTravelDetails]);

  return (
    <>
      {details && details.Lat && details.Lng && (
        <div className="bg-white rounded-lg shadow-lg mt-6">
          <div className="flex justify-between items-center p-4">
            <h2 className="text-lg font-semibold text-gray-800">
              Live Location
            </h2>
            <button className="bg-[#00A76F] rounded-md px-4 py-2 text-white font-semibold">
              Active
            </button>
          </div>
          <TravelMap data={details} />
        </div>
      )}
    </>
  );
}
